import DiscountBtnV2 from 'assets/Icons/discountBtnV2';
import Tip from 'assets/Icons/tip';
import CashBtnV2 from 'assets/Icons/cashBtnV2';
import ClearTurn from 'assets/Icons/clearTurn';
import TotalSale from 'assets/Icons/totalSale';
import IcCommission from 'assets/Icons/IcCommission';
import IcTotal from 'assets/Icons/IcTotal';
import IcFeeV2 from 'assets/Icons/IcFee';
import IcPayment from 'assets/Icons/IcPayment';
import IcList from 'assets/Icons/IcList';
import { EHideFieldReport } from 'utils/hide-field-report';

export interface IReportSection {
  key: string;
  label: string;
  labelPreview?: string;
  rows?: string[];
  description?: string;
  icon?: React.ReactNode;
  bgColor?: string;
  isHeader?: boolean;
  isHiddenBorder?: boolean;
  isPaymentType?: boolean;
  subrows?: string[];
}

export const REPORT_SECTIONS: IReportSection[] = [
  {
    key: EHideFieldReport.TOTAL_SALE,
    label: 'Total Sales',
    labelPreview: 'TOTAL SALES',
    icon: <TotalSale width={24} height={24} fill='#232F3E' />,
  },
  {
    key: EHideFieldReport.SUPPLY_FEE,
    label: 'Supply Fees',
    labelPreview: 'SUPPLY FEES',
    icon: <IcFeeV2 width={24} height={24} fill='#232F3E' />,
    isHiddenBorder: true,
  },
  {
    key: EHideFieldReport.TOTAL,
    label: 'Total',
    labelPreview: 'TOTAL',
    icon: <IcTotal width={24} height={24} />,
    bgColor: '#232F3E',
    isHeader: true,
  },
  {
    key: EHideFieldReport.COMMISSION,
    label: 'Commission',
    labelPreview: 'COMMISSION (%)',
    icon: <IcCommission width={24} height={24} fill='#232F3E' />,
  },
  {
    key: EHideFieldReport.DISCOUNT,
    label: 'Discount',
    labelPreview: 'DISCOUNT',
    icon: <DiscountBtnV2 width={24} height={24} fill='#232F3E' />,
  },
  {
    key: EHideFieldReport.TIP_COLLECTED,
    label: 'Collected Tips',
    labelPreview: 'COLLECTED TIPS',
    icon: <Tip width={24} height={24} fill='#232F3E' />,
  },
  {
    key: EHideFieldReport.CLEANING_FEE,
    label: 'Cleaning Fees',
    labelPreview: 'CLEANING FEES',
    icon: <ClearTurn width={24} height={24} fill='#232F3E' />,
    isHiddenBorder: true,
  },
  {
    key: EHideFieldReport.PAYMENT_TYPE,
    label: 'Payment Types',
    labelPreview: 'PAYMENT TYPES',
    rows: ['Credit Card', 'Cash', 'Gift Card', 'Loyalty', 'Other'],
    icon: <IcPayment width={24} height={24} fill='#232F3E' />,
    bgColor: '#232F3E',
    isHeader: true,
    isHiddenBorder: true,
    isPaymentType: true,
  },
  {
    key: EHideFieldReport.PAYROLL,
    label: 'Payroll',
    labelPreview: 'PAYROLL',
    icon: <CashBtnV2 width={24} height={24} fill='#FFF' />,
    bgColor: '#232F3E',
    isHeader: true,
  },
  {
    key: EHideFieldReport.PAYROLL_DETAIL,
    label: 'Payroll Details',
    description:
      'Included: Bonus (%), Check (%), Tip To Bonus (%), Tip To Check (%), Tax Withholdings, Total Bonus, Total Check',
    subrows: [
      'Bonus (%)',
      'Check (%)',
      'Tip To Bonus (%)',
      'Tip To Check (%)',
    ],
    rows: [
      'Federal Tax Withheld (0%)',
      'Social Security Tax Withheld (0%)',
      'Medicare Tax Withheld (0%)',
      'Total Bonus',
      'Total Check',
    ],
    icon: <IcList width={24} height={24} fill='#232F3E' />,
    isHiddenBorder: true,
  },
];
